<template>
  <component :is="dynamicDraw" class="emeraldraws" />
</template>

<script>
export default {
  name: 'Emeraldraw',
  props: {
    draw: {
      type: String,
      required: true
    }
  },
  computed: {
    dynamicDraw () {
      return () => import(/* webpackChunkName: "draws/draw-[request]" */ '@/assets/emeraldraws/' + this.draw + '.svg?inline')
    }
  }
}
</script>
